// extracted by mini-css-extract-plugin
export default {"container":"categoriesDropDown-module--container--oszlX","content":"categoriesDropDown-module--content--qg-h1","noMoreViolence":"categoriesDropDown-module--noMoreViolence--nnhks"};